/**
 * What an organization's OWN screens show about its conversion (SD-10570).
 *
 * NOT the same enum as `TreasuryConversionStatus`, and keeping them apart is deliberate rather
 * than duplication. That one is the super's roster of every organization and carries conversion
 * MECHANICS — blockers, the selected Connect account, the last error. This one is what a single
 * association is told about itself, and it has four values because four is how many distinct
 * things its screens need to do.
 *
 * The clearest case for two enums: a NATIVE Treasury organization reads `already_on_treasury` on
 * the roster, because the super needs to see why that row is not actionable, and `NONE` here,
 * because the organization has no conversion experience to show — it never had one. One shared
 * enum would force one of those two audiences to be told something false.
 *
 * Received, never computed. Core derives it with an ordered cascade that ranks the negating events
 * first, so a rolled-back organization reads NONE even though its Treasury deposit account
 * survives the rollback.
 */
export enum TreasuryConversionStage {
    /**
     * Nothing to show. No conversion, or one that was rolled back or abandoned, or an
     * organization that was always on Treasury.
     */
    NONE = 'none',
    /**
     * Marked, and not yet usable. Covers both pre-approval and the approval-to-provisioning
     * window, which is a real state an organization can sit in for a long time.
     */
    AWAITING_CAPABILITY = 'awaiting_capability',
    /** A Treasury deposit account exists. The financial-account screen has something to show. */
    PROVISIONED = 'provisioned',
    /** Switched over. Invoices now point at the Treasury account. */
    CONVERTED = 'converted',
}
